document.addEventListener('rebuy:cart.change', () => {
	fetch('/cart.js', { cache: 'no-store' })
		.then((response) => response.json())
		.then((cart) => {
			document.querySelectorAll('.header__icons--cart-open .cart-count').forEach((el) => {
				el.textContent = cart.item_count
			})
		})
		.catch(() => {})
})

function equalizeCardHeights(slideSelector, contentSelector) {
	const slides = document.querySelectorAll(slideSelector)
	const contents = document.querySelectorAll(`${slideSelector} ${contentSelector}`)
	let maxHeight = 0

	contents.forEach((el) => {
		el.style.minHeight = ''
	})

	slides.forEach((slide) => {
		const content = slide.querySelector(contentSelector)
		if (!content) return
		const currentHeight = content.getBoundingClientRect().height + 2
		if (currentHeight > maxHeight) maxHeight = currentHeight
	})

	contents.forEach((el) => {
		el.style.minHeight = `${maxHeight}px`
	})
}

function equalizeSectionHeights() {
	equalizeCardHeights('.section--testimonials swiper-container swiper-slide', '.card--testimonial__content')
	equalizeCardHeights('.section--blog-posts swiper-container swiper-slide', '.card__content')
}

document.addEventListener('DOMContentLoaded', equalizeSectionHeights)
window.addEventListener('resize', equalizeSectionHeights)

function l_para_style_pandectes_cookie() {
	// 1. Selector for the Pandectes cookie consent popup
	const hostSelector = 'pandectes-cmp'

	// 2. Define the custom CSS rules for the button inside the shadow DOM
	const cssRules = `
    :is(.widget,.dialog).left {
      --spacing: 0.175em;
      left: 11px !important;
      bottom: 60px !important;
    }

    @media (min-width: 1024px) {
      :is(.widget,.dialog).left {
        --spacing: 0.255em;
        left: 21px !important;
        bottom: 80px !important;
      }
    }
  `

	// 3. Wait for the popup to render, then inject CSS into the Shadow DOM
	const checkExist = setInterval(() => {
		const host = document.querySelector(hostSelector)

		if (host && host.shadowRoot) {
			const style = document.createElement('style')
			style.textContent = cssRules
			host.shadowRoot.appendChild(style)

			clearInterval(checkExist) // Stop the interval once the CSS is successfully injected
		}
	}, 100)

	// Safety timeout: stop checking after 5 seconds to prevent memory leaks if the popup doesn't load
	setTimeout(() => clearInterval(checkExist), 5000)
}

window.addEventListener('DOMContentLoaded', () => {
	l_para_style_pandectes_cookie()
})

// =====================
// DOM Manipulation Utils
// =====================

function l_setInnerHTML(element, html) {
	element.innerHTML = html
	element.querySelectorAll('script').forEach((oldScript) => {
		const newScript = document.createElement('script')
		const attributes = [...oldScript.attributes]

		attributes.forEach((attr) => {
			newScript.setAttribute(attr.name, attr.value)
		})

		newScript.appendChild(document.createTextNode(oldScript.innerHTML))
		oldScript.parentNode.replaceChild(newScript, oldScript)
	})
}

function l_swapHtmlNode(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
	// Run pre-process callbacks on new content
	if (Array.isArray(preProcessCallbacks)) {
		preProcessCallbacks.forEach((cb) => cb?.(newContent))
	}

	// Create a new node from newContent's outerHTML (ensures scripts run)
	const wrapper = document.createElement('div')
	l_setInnerHTML(wrapper, newContent.outerHTML)
	const newNode = wrapper.firstElementChild

	// Deduplicate [id] and [form] in oldNode's subtree
	const timestampKey = Date.now()
	oldNode.querySelectorAll('[id], [form]').forEach((el) => {
		if (el.id) el.id = `${el.id}-${timestampKey}`
		if (el.form) {
			const formId = el.getAttribute('form')
			if (formId) el.setAttribute('form', `${formId}-${timestampKey}`)
		}
	})

	// Insert newNode before oldNode and hide oldNode
	oldNode.parentNode.insertBefore(newNode, oldNode)
	oldNode.style.display = 'none'

	// Run post-process callbacks
	if (Array.isArray(postProcessCallbacks)) {
		postProcessCallbacks.forEach((cb) => cb?.(newNode))
	}

	// Remove oldNode after transition
	setTimeout(() => {
		if (oldNode?.parentNode) oldNode.remove()
	}, 500)
}

function l_addClassesToRteTables() {
	document.querySelectorAll('.l-rte table, .shopify-policy__body .rte table').forEach((table) => {
		table.classList.add('l-cTable')

		if (table.parentElement?.classList.contains('l-rte-table')) return

		const wrapper = document.createElement('div')

		wrapper.classList.add('l-rte-table', 'l-overflow-x-auto', 'l-scrollbar-hidden')
		table.parentNode.insertBefore(wrapper, table)
		wrapper.appendChild(table)
	})
}

function l_smoothScrollOnAnchorTags() {
	document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
		const id = anchor.getAttribute('href').split('#')?.[1]
		if (!id) return

		anchor.addEventListener('click', (e) => {
			e.preventDefault()

			const target = document.querySelector(anchor.getAttribute('href'))
			target?.scrollIntoView?.({ behavior: 'smooth', block: 'center', inline: 'center' })
		})
	})
}

function l_preloadImage(container) {
	const imageEls = container.querySelectorAll('img')

	imageEls.forEach((imageEl) => {
		if (imageEl.complete) return

		const image = new Image()
		image.src = imageEl.src
	})
}

function l_getSectionDOM(html, selector = '.shopify-section') {
	return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)
}

function l_extractSectionId(element) {
	element = element.classList.contains('shopify-section') ? element : element.closest('.shopify-section')

	return element.id.replace('shopify-section-', '')
}

// =====================
// DOM Observation Utils
// =====================

const l_getElement = (targetSelector, container) => {
	if (targetSelector instanceof Element) return targetSelector
	if (typeof targetSelector === 'string') {
		return targetSelector.startsWith('#')
			? container.getElementById(targetSelector.slice(1))
			: container.querySelector(targetSelector)
	}

	return null
}

function l_watchDOMChanges({ target, container = document, callback, once = false }) {
	const watchedEl = l_getElement(target, container)
	if (!watchedEl) return null

	const observer = new MutationObserver((mutationsList, obs) => {
		for (const mutation of mutationsList) {
			if (mutation.type === 'childList' && mutation.addedNodes.length) {
				callback(mutation.addedNodes, watchedEl)
				if (once) {
					obs.disconnect()
					break
				}
			}
		}
	})

	observer.observe(watchedEl, {
		attributes: true,
		childList: true,
		subtree: true,
	})

	return observer
}

function l_isElementInViewport(el) {
	const rect = el.getBoundingClientRect()
	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
		rect.right <= (window.innerWidth || document.documentElement.clientWidth)
	)
}

// =====================
// String Utilities
// =====================

function l_normalizeString(str) {
	return str
		.normalize('NFD')
		.replace(/\p{Diacritic}/gu, '')
		.toLowerCase()
}

function l_handleize(str) {
	return str
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '')
		.toLowerCase()
		.replace(/[^a-z0-9]+/g, '-')
		.replace(/^-+|-+$/g, '')
		.replace(/--+/g, '-')
}

// =====================
// Focus Management & Trap Focus
// =====================

function l_debounce(fn, wait = 0) {
	let timeoutId

	return function (...args) {
		clearTimeout(timeoutId)
		timeoutId = setTimeout(() => fn.apply(this, args), wait)
	}
}

function isVisible(element) {
	if (!element) return false

	if (element.closest('[aria-hidden="true"], [hidden]')) return false

	const detailsParent = element.closest('details')
	if (detailsParent && !detailsParent.open && !detailsParent.contains(element.closest('summary'))) {
		return false
	}

	if (element.offsetParent === null && getComputedStyle(element).position !== 'fixed') {
		return false
	}

	const style = getComputedStyle(element)
	if (style.visibility === 'hidden' || style.visibility === 'collapse') return false

	if (element.getClientRects().length === 0) return false

	return true
}

function l_getFocusableElements(container) {
	const focusableSelectors = `summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe`

	return Array.from(container.querySelectorAll(focusableSelectors)).filter((el) => isVisible(el))
}

function l_disableFocusableElements(container) {
	l_getFocusableElements(container).forEach((el) => {
		el.setAttribute('tabindex', '-1')
		el.setAttribute('aria-disabled', 'true')
	})
}

function l_enableFocusableElements(container) {
	l_getFocusableElements(container).forEach((el) => {
		el.removeAttribute('tabindex')
		el.removeAttribute('aria-disabled')
	})
}

const l_focusTrapStack = []

function l_createFocusTrapLayer(container, defaultElementToFocus, enableFocusRange = true) {
	const layer = {
		container,
		defaultElementToFocus,
		enableFocusRange,
		_keydownAttached: false,
	}

	layer.handlers = {
		keydown(event) {
			const key = event.code?.toUpperCase()
			const isTab = key === 'TAB'
			const isArrowDown = key === 'ARROWDOWN'
			const isArrowUp = key === 'ARROWUP'

			const elements = l_getFocusableElements(layer.container)
			const [first, last] = [elements[0], elements[elements.length - 1]]
			const currentIndex = elements.indexOf(event.target)

			if (!elements.length) return

			if (isTab) {
				if ((event.target === last || last?.contains?.(event.target)) && !event.shiftKey) {
					event.preventDefault()
					first?.focus()
				} else if ((event.target === layer.container || first?.contains?.(event.target)) && event.shiftKey) {
					event.preventDefault()
					last?.focus()
				}
				return
			}

			/* Arrow ↑/↓ only when enableFocusRange — drawers/menus often need native arrows */
			if (!layer.enableFocusRange) return

			if (isArrowDown) {
				event.preventDefault()
				if (currentIndex === -1 || currentIndex === elements.length - 1) {
					first?.focus()
				} else {
					elements[currentIndex + 1]?.focus()
				}
				return
			}

			if (isArrowUp) {
				event.preventDefault()
				if (currentIndex === -1 || currentIndex === 0) {
					last?.focus()
				} else {
					elements[currentIndex - 1]?.focus()
				}
			}
		},
		focusin(event) {
			if (!layer.container.contains(event.target)) return

			if (!layer._keydownAttached) {
				document.addEventListener('keydown', layer.handlers.keydown)
				layer._keydownAttached = true
			}
		},
		focusout() {
			if (!layer._keydownAttached) return

			document.removeEventListener('keydown', layer.handlers.keydown)
			layer._keydownAttached = false
		},
	}

	layer.activate = ({ focus = true } = {}) => {
		document.addEventListener('focusin', layer.handlers.focusin)
		document.addEventListener('focusout', layer.handlers.focusout)

		if (!focus) return

		const elements = l_getFocusableElements(layer.container)
		const elementToFocus = layer.defaultElementToFocus || elements[0]

		if (!elementToFocus) return

		elementToFocus.focus()

		if (
			elementToFocus.tagName === 'INPUT' &&
			['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
			elementToFocus.value &&
			layer.enableFocusRange
		) {
			elementToFocus.setSelectionRange(0, elementToFocus.value.length)
		}
	}

	layer.deactivate = () => {
		document.removeEventListener('focusin', layer.handlers.focusin)
		document.removeEventListener('focusout', layer.handlers.focusout)

		if (layer._keydownAttached) {
			document.removeEventListener('keydown', layer.handlers.keydown)
			layer._keydownAttached = false
		}
	}

	return layer
}

function l_shouldReplaceTrapLayer(topLayer, container) {
	if (!topLayer) return false
	if (topLayer.container === container) return true

	return topLayer.container.contains(container) || container.contains(topLayer.container)
}

function l_trapFocus(container, defaultElementToFocus, enableFocusRange = true, moveFocus = true) {
	const topLayer = l_focusTrapStack.at(-1)

	if (l_shouldReplaceTrapLayer(topLayer, container)) {
		topLayer.deactivate()
		l_focusTrapStack.pop()
	} else {
		topLayer?.deactivate()
	}

	const layer = l_createFocusTrapLayer(container, defaultElementToFocus, enableFocusRange)
	l_focusTrapStack.push(layer)
	layer.activate({ focus: moveFocus })
}

function l_removeTrapFocus(elementToFocus = null) {
	const topLayer = l_focusTrapStack.pop()
	topLayer?.deactivate()

	const previousLayer = l_focusTrapStack.at(-1)

	if (previousLayer) {
		// Resume parent trap (stacked drawers / nested modals), then return focus to the trigger
		previousLayer.activate({ focus: false })
		elementToFocus?.focus?.()
	} else if (elementToFocus) {
		elementToFocus.focus()
	}
}

// =====================
// Scroll & Body Lock Utilities
// =====================

function l_setBodyScrollbarWidth() {
	const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth
	document.documentElement.style.setProperty('--l-body-scrollbar-width', `${scrollBarWidth}px`)
}

function l_lockBodyScroll(elementName) {
	// Add classes
	document.body.classList.add('js-block-page')

	if (elementName) {
		document.body.classList.add(`js-block-page-${elementName}`)
	}
}

function l_unLockBodyScroll(elementName) {
	// Remove classes
	if (elementName) {
		document.body.classList.remove(`js-block-page-${elementName}`)

		const isExistAnotherBlockedClass = Array.from(document.body.classList).some((cls) =>
			cls.startsWith('js-block-page-')
		)

		!isExistAnotherBlockedClass && document.body.classList.remove('js-block-page')
	} else {
		document.body.classList.remove('js-block-page')
	}
}

function l_setupVariablesBeforeOpenModal() {
	// Elements — prefer custom element over hardcoded id
	const headerSection = document.getElementById('nav-wrapper')

	// Set CSS variables
	document.documentElement.style.setProperty('--l-viewport-height', `${visualViewport?.height ?? window.innerHeight}px`)
	document.documentElement.style.setProperty('--l-header-height', `${headerSection?.offsetHeight || 0}px`)
	document.documentElement.style.setProperty('--l-announcement-bar-height', `0px`)

	return {
		headerHeight: headerSection?.offsetHeight || 0,
		announcementBarHeight: 0,
		headerTotalHeight: headerSection?.offsetHeight || 0,
		viewportHeight: visualViewport?.height ?? window.innerHeight,
	}
}

// =====================
// Media Controls
// =====================

function l_pauseAllMedia(container = document) {
	container.querySelectorAll('iframe').forEach((iframe) => {
		const src = iframe.getAttribute('src') || ''
		if (src.includes('youtube')) {
			iframe.contentWindow?.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*')
		} else if (src.includes('vimeo')) {
			iframe.contentWindow?.postMessage('{"method":"pause"}', '*')
		}
	})
	container.querySelectorAll('l-product-model').forEach((model) => {
		if (model.modelViewerUI) model.modelViewerUI.pause()
	})
	container.querySelectorAll('video').forEach((video) => {
		video.pause()
	})
}

function l_playMedia(container = document) {
	container.querySelectorAll('iframe').forEach((iframe) => {
		const src = iframe.getAttribute('src') || ''
		if (src.includes('youtube')) {
			iframe.contentWindow?.postMessage('{"event":"command","func":"playVideo","args":""}', '*')
		} else if (src.includes('vimeo')) {
			iframe.contentWindow?.postMessage('{"method":"play"}', '*')
		}
	})
	container.querySelectorAll('l-product-model').forEach((model) => {
		if (model.modelViewerUI) model.modelViewerUI.play()
	})
	container.querySelectorAll('video').forEach((video) => {
		video.play()
	})
}

// =====================
// Money Formatting
// =====================

function l_formatMoney(cents, format = '') {
	let value = ''
	const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
	let formatString = format || window.LTATheme?.money?.format || '${{amount}}'

	if (typeof formatString === 'string') {
		formatString = formatString.replace(/^"|"$/g, '').trim()
	}

	if (typeof cents == 'string') {
		cents = cents.replace('.', '')
	}

	function defaultOption(opt, def) {
		return typeof opt == 'undefined' ? def : opt
	}

	function formatWithDelimiters(number, precision, thousands, decimal) {
		precision = defaultOption(precision, 2)
		thousands = defaultOption(thousands, ',')
		decimal = defaultOption(decimal, '.')

		if (isNaN(number) || number == null) {
			return 0
		}

		number = (number / 100.0).toFixed(precision)

		var parts = number.split('.'),
			dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
			centsPart = parts[1] ? decimal + parts[1] : ''

		return dollars + centsPart
	}

	const placeholder = formatString.match(placeholderRegex)?.[1] || 'amount'

	switch (placeholder) {
		case 'amount':
			value = formatWithDelimiters(cents, 2)
			break
		case 'amount_no_decimals':
			value = formatWithDelimiters(cents, 0)
			break
		case 'amount_with_comma_separator':
			value = formatWithDelimiters(cents, 2, '.', ',')
			break
		case 'amount_no_decimals_with_comma_separator':
			value = formatWithDelimiters(cents, 0, '.', ',')
			break
		case 'amount_with_apostrophe_separator':
			value = formatWithDelimiters(cents, 2, "'")
			break
		case 'amount_no_decimals_with_space_separator':
			value = formatWithDelimiters(cents, 0, ' ')
			break
		case 'amount_with_space_separator':
			value = formatWithDelimiters(cents, 2, ' ')
			break
		case 'amount_with_period_and_space_separator':
			value = formatWithDelimiters(cents, 2, ' ', ',')
			break
		default:
			value = formatWithDelimiters(cents, 2)
	}

	return formatString.replace(placeholderRegex, value)
}

/************************************************************************************

* [ADD TO CART MODULE]

*************************************************************************************/

class LTACartServices {
	constructor(cartDrawer = null) {
		this.cartDrawer = cartDrawer
	}

	getBaseConfig() {
		return {
			method: 'POST',
			headers: {
				'X-Requested-With': 'XMLHttpRequest',
			},
		}
	}

	createConfigFromForm(formEl) {
		const config = this.getBaseConfig()
		const formData = new FormData(formEl)

		config.body = formData

		return config
	}

	createConfigFromItems(items = []) {
		const config = this.getBaseConfig()
		const formData = new FormData()

		items.forEach((item, index) => {
			const prefix = `items[${index}]`

			formData.append(`${prefix}[id]`, item.id)
			formData.append(`${prefix}[quantity]`, item.quantity)
			if (item.selling_plan) {
				formData.append(`${prefix}[selling_plan]`, item.selling_plan)
			}

			// Add all other properties from the item object except id, quantity, and selling_plan
			Object.entries(item).forEach(([key, value]) => {
				if (['id', 'quantity', 'selling_plan'].includes(key)) return
				// If the value is an object, serialize it as JSON
				if (typeof value === 'object' && value !== null) {
					formData.append(`${prefix}[${key}]`, JSON.stringify(value))
				} else if (value !== undefined) {
					formData.append(`${prefix}[${key}]`, value)
				}
			})
		})

		config.body = formData
		return config
	}

	async addToCart(config, id = 'default') {
		// Note: Don't use finally / catch here

		return fetch(`${window.LTATheme.routes.cart_add_url}.js`, config)
			.then((res) => res.json())
			.then((data) => {
				if (data?.status) {
					document.dispatchEvent(
						new CustomEvent('l:cart:error', {
							detail: {
								id,
								description: data.description,
								message: data.message,
								errors: data.errors || data.description,
								productVariantId: config.body instanceof FormData ? config.body.get('id') : undefined,
							},
						})
					)

					return data
				}

				document.dispatchEvent(new CustomEvent('l:product:added', { bubbles: true, detail: { id, response: data } }))

				return data
			})
	}

	async changeCartLineItem(formData) {
		return fetch(`${window.LTATheme.routes.cart_change_url}.js`, { ...l_fetchConfig(), body: JSON.stringify(formData) })
			.then((res) => res.json())
			.then((data) => {
				return data
			})
	}
}

const ltaCartService = new LTACartServices()

/*****************************************
 * [COMPONENT]: QUANTITY INPUT
 ******************************************/

if (!customElements.get('l-qty-input')) {
	class LTAQtyInput extends HTMLElement {
		constructor() {
			super()

			this.onButtonClick = this.onButtonClick.bind(this)
			this.onInputChange = this.onInputChange.bind(this)
			this.onInputBeforeChange = this.onInputBeforeChange.bind(this)
		}

		connectedCallback() {
			this.input = this.querySelector('input')
			this.buttonMinus = this.querySelector("button[name='minus']")
			this.buttonPlus = this.querySelector("button[name='plus']")

			if (!this.input) return

			this.changeEvent = new Event('change', { bubbles: true })

			this.validateQtyRules()
			this.setupEventListeners()
		}

		setupEventListeners() {
			this.input.addEventListener('input', this.onInputBeforeChange)
			this.input.addEventListener('change', this.onInputChange)
			this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.onButtonClick))
		}

		onInputBeforeChange() {
			const value = parseInt(this.input.value)

			if (isNaN(value)) return

			const min = parseInt(this.input.min)
			const max = parseInt(this.input.max)
			let newValue = value

			if (!isNaN(min) && value < min) {
				newValue = min
			}

			if (!isNaN(max) && value > max) {
				newValue = max
			}

			if (newValue !== value) {
				this.input.value = newValue
			}
		}

		onInputChange() {
			this.validateQtyRules()
		}

		onButtonClick(event) {
			event.preventDefault()

			const previousValue = this.input.value
			const buttonName = event.currentTarget.name

			if (buttonName === 'plus') {
				this.incrementQuantity()
			} else if (buttonName === 'minus') {
				this.decrementQuantity()
			}

			if (previousValue !== this.input.value) {
				this.input.dispatchEvent(this.changeEvent)
				this.onQuantityChanged(previousValue, parseInt(this.input.value))
			}
		}

		onQuantityChanged(oldValue, newValue) {
			// Override in child classes if needed
		}

		incrementQuantity() {
			const min = parseInt(this.input.min, 10)
			const step = parseInt(this.input.step, 10)
			const value = parseInt(this.input.value, 10)

			if (!isNaN(min) && !isNaN(step) && min > step && value === 0) {
				this.input.value = min
			} else {
				this.input.stepUp()
			}
		}

		decrementQuantity() {
			this.input.stepDown()

			const min = this.input.min
			if (min && min === this.input.value) {
				this.input.value = parseInt(this.input.min, 10)
			}
		}

		validateQtyRules() {
			const value = parseInt(this.input.value)

			if (this.input.min && this.buttonMinus) {
				this.buttonMinus.toggleAttribute('disabled', value <= parseInt(this.input.min))
			}

			if (this.input.max && this.buttonPlus) {
				this.buttonPlus.toggleAttribute('disabled', value >= parseInt(this.input.max))
			}
		}

		disconnectedCallback() {
			if (this.input) {
				this.input.removeEventListener('input', this.onInputBeforeChange)
				this.input.removeEventListener('change', this.onInputChange)
			}

			this.querySelectorAll('button').forEach((button) => button.removeEventListener('click', this.onButtonClick))
		}
	}

	customElements.define('l-qty-input', LTAQtyInput)
}

/*****************************************
 * [COMPONENT]: CUSTOM SELECT
 * Combobox/listbox over a native <select>.
 * Mobile = bottom sheet; desktop = dropdown under trigger.
 *****************************************/

if (!customElements.get('l-custom-select')) {
	class LTACustomSelect extends HTMLElement {
		static MOBILE_MQ = '(max-width: 767px)'
		static SECTION_OPEN_CLASS = 'is-cCSelect-open'
		static HIDE_DELAY_MS = 400

		constructor() {
			super()
			this._onTriggerClick = this._onTriggerClick.bind(this)
			this._onTriggerKeydown = this._onTriggerKeydown.bind(this)
			this._onCloseClick = this.close.bind(this)
			this._onNativeChange = this._syncFromNative.bind(this)
			this._onOptionClick = this._onOptionClick.bind(this)
			this._onOutsideClick = this._onOutsideClick.bind(this)
			this._onDocumentKeydown = this._onDocumentKeydown.bind(this)

			this._cleanups = []
			this._isOpen = false
			this._sectionEl = null
			this._hideModalTimer = null
		}

		/* ---------------------------------
		 * Lifecycle
		 * --------------------------------- */

		connectedCallback() {
			this._cacheElements()
			if (!this._isReady()) return

			this.changeEvent = new Event('change', { bubbles: true })
			this._bindEvents()
			this._syncFromNative()
		}

		disconnectedCallback() {
			this._clearHideModalTimer()
			this._releaseSection()
			this._unbindWindowListeners()
			this._runCleanups()
		}

		/* ---------------------------------
		 * Setup
		 * --------------------------------- */

		_cacheElements() {
			this.triggerEl = this.querySelector('[data-trigger]')
			this.triggerContentEl = this.querySelector('[data-trigger-content]') || this.triggerEl
			this.modalEl = this.querySelector('[data-modal]')
			this.modalContainerEl = this.querySelector('[data-modal-container]')
			this.listboxEl = this.querySelector('[role="listbox"]')
			this.nativeSelectEl = this.querySelector('select')
			this.optionEls = Array.from(this.querySelectorAll('[data-option-value][role="option"]'))
			this.closeEls = this.querySelectorAll('[data-close]')
			this._sectionEl = this.closest('.shopify-section')
		}

		_isReady() {
			return Boolean(this.triggerEl && this.modalEl && this.nativeSelectEl && this.listboxEl && this.optionEls.length)
		}

		_bindEvents() {
			this.triggerEl.addEventListener('click', this._onTriggerClick)
			this.triggerEl.addEventListener('keydown', this._onTriggerKeydown)
			this._cleanups.push(() => {
				this.triggerEl.removeEventListener('click', this._onTriggerClick)
				this.triggerEl.removeEventListener('keydown', this._onTriggerKeydown)
			})

			this.closeEls.forEach((el) => {
				el.addEventListener('click', this._onCloseClick)
				this._cleanups.push(() => el.removeEventListener('click', this._onCloseClick))
			})

			this.nativeSelectEl.addEventListener('change', this._onNativeChange)
			this._cleanups.push(() => this.nativeSelectEl.removeEventListener('change', this._onNativeChange))

			this.optionEls.forEach((optionEl) => {
				optionEl.addEventListener('click', this._onOptionClick)
				this._cleanups.push(() => optionEl.removeEventListener('click', this._onOptionClick))
			})
		}

		_runCleanups() {
			this._cleanups.forEach((fn) => {
				try {
					fn()
				} catch {}
			})
			this._cleanups = []
		}

		/* ---------------------------------
		 * Helpers
		 * --------------------------------- */

		_isMobile() {
			return window.matchMedia(LTACustomSelect.MOBILE_MQ).matches
		}

		_isRtl() {
			return getComputedStyle(this).direction === 'rtl'
		}

		/* Skips only aria-disabled (true non-operable). Sold-out stays selectable. */
		_enabledOptions() {
			return this.optionEls.filter((el) => el.getAttribute('aria-disabled') !== 'true')
		}

		_elevateSection() {
			this._sectionEl?.classList.add(LTACustomSelect.SECTION_OPEN_CLASS)
		}

		_releaseSection() {
			this._sectionEl?.classList.remove(LTACustomSelect.SECTION_OPEN_CLASS)
		}

		_clearHideModalTimer() {
			if (this._hideModalTimer == null) return
			clearTimeout(this._hideModalTimer)
			this._hideModalTimer = null
		}

		_bindWindowListeners() {
			window.addEventListener('click', this._onOutsideClick)
			window.addEventListener('keydown', this._onDocumentKeydown)
		}

		_unbindWindowListeners() {
			window.removeEventListener('click', this._onOutsideClick)
			window.removeEventListener('keydown', this._onDocumentKeydown)
		}

		/* ---------------------------------
		 * Open / close
		 * --------------------------------- */

		_onTriggerClick(event) {
			event.preventDefault()
			if (this.triggerEl.disabled) return
			this._isOpen ? this.close() : this.open()
		}

		_onTriggerKeydown(event) {
			const key = event.key
			if (
				key !== 'ArrowDown' &&
				key !== 'ArrowUp' &&
				key !== 'ArrowLeft' &&
				key !== 'ArrowRight' &&
				key !== 'Enter' &&
				key !== ' '
			) {
				return
			}

			event.preventDefault()
			if (this._isOpen) return

			const rtl = this._isRtl()
			const openLast = key === 'ArrowUp' || key === (rtl ? 'ArrowRight' : 'ArrowLeft')
			this.open(openLast ? 'last' : 'selected')
		}

		open(focusTarget = 'selected') {
			if (this._isOpen || this.triggerEl.disabled) return
			if (this.modalEl.classList.contains('is-hidden')) return

			this._clearHideModalTimer()
			this._isOpen = true
			this.triggerEl.classList.add('is-active')
			this.triggerEl.setAttribute('aria-expanded', 'true')

			const isMobile = this._isMobile()
			if (isMobile) this._elevateSection()

			this.modalEl.hidden = false
			this.modalEl.classList.remove('l-hidden')
			requestAnimationFrame(() => this.modalEl.classList.add('is-active'))

			if (isMobile && typeof l_lockBodyScroll === 'function') {
				l_lockBodyScroll('custom-select')
			}

			this._focusInitialOption(focusTarget)

			if (typeof l_trapFocus === 'function') {
				l_trapFocus(this.modalContainerEl || this.modalEl, this.triggerEl)
			}

			// Defer: opening click must not count as an outside click
			requestAnimationFrame(() => {
				if (!this._isOpen) return
				this._bindWindowListeners()
			})
		}

		close() {
			if (!this._isOpen) return

			this._isOpen = false
			this.triggerEl.classList.remove('is-active')
			this.triggerEl.setAttribute('aria-expanded', 'false')
			this.modalEl.classList.remove('is-active')
			this._clearActiveOption()

			const wasElevated = this._sectionEl?.classList.contains(LTACustomSelect.SECTION_OPEN_CLASS)
			if (wasElevated && typeof l_unLockBodyScroll === 'function') {
				l_unLockBodyScroll('custom-select')
			}

			this._scheduleHideModal()
			this._returnFocusToTrigger()
			this._unbindWindowListeners()
		}

		_scheduleHideModal() {
			this._clearHideModalTimer()
			this._hideModalTimer = setTimeout(() => {
				this._hideModalTimer = null
				if (this._isOpen) return
				this.modalEl.classList.add('l-hidden')
				this.modalEl.hidden = true
				this._releaseSection()
			}, LTACustomSelect.HIDE_DELAY_MS)
		}

		_returnFocusToTrigger() {
			if (typeof l_removeTrapFocus === 'function') {
				l_removeTrapFocus(this.triggerEl)
				return
			}
			this.triggerEl.focus()
		}

		_onOutsideClick(event) {
			const target = event.target
			if (this.triggerEl.contains(target) || this.modalEl.contains(target)) return
			this.close()
		}

		/* ---------------------------------
		 * Keyboard (listbox: arrows, not Tab)
		 * --------------------------------- */

		_onDocumentKeydown(event) {
			if (!this._isOpen) return

			const options = this._enabledOptions()
			if (!options.length) return

			const key = event.key

			if (key === 'Escape') {
				event.preventDefault()
				this.close()
				return
			}

			if (
				key === 'ArrowDown' ||
				key === 'ArrowUp' ||
				key === 'ArrowLeft' ||
				key === 'ArrowRight' ||
				key === 'Home' ||
				key === 'End'
			) {
				event.preventDefault()
				this._moveActiveOption(key, options)
				return
			}

			if (key === 'Enter' || key === ' ') {
				event.preventDefault()
				const active = options.find((el) => el.getAttribute('data-active') === 'true')
				if (active) this._selectOption(active)
			}
		}

		_moveActiveOption(key, options) {
			let index = options.findIndex((el) => el.getAttribute('data-active') === 'true')
			if (index < 0) index = 0

			/* Horizontal arrows follow reading direction (RTL flips Left/Right) */
			const rtl = this._isRtl()
			const isNext = key === 'ArrowDown' || key === (rtl ? 'ArrowLeft' : 'ArrowRight')
			const isPrev = key === 'ArrowUp' || key === (rtl ? 'ArrowRight' : 'ArrowLeft')

			if (isNext) index = Math.min(index + 1, options.length - 1)
			if (isPrev) index = Math.max(index - 1, 0)
			if (key === 'Home') index = 0
			if (key === 'End') index = options.length - 1

			this._setActiveOption(options[index])
		}

		/* ---------------------------------
		 * Selection / sync
		 * --------------------------------- */

		_onOptionClick(event) {
			const optionEl = event.currentTarget
			if (optionEl.getAttribute('aria-disabled') === 'true') return
			this._selectOption(optionEl)
		}

		_selectOption(optionEl) {
			const value = optionEl.dataset.optionValue
			if (value == null) return

			this.nativeSelectEl.value = value
			Array.from(this.nativeSelectEl.options).forEach((opt) => {
				if (opt.value === value) opt.setAttribute('selected', 'selected')
				else opt.removeAttribute('selected')
			})

			this.nativeSelectEl.dispatchEvent(this.changeEvent)
			this._syncFromNative()
			this.close()
		}

		_focusInitialOption(focusTarget) {
			const options = this._enabledOptions()
			let index = options.findIndex((el) => el.classList.contains('is-selected'))
			if (focusTarget === 'last') index = options.length - 1
			if (index < 0) index = 0
			this._setActiveOption(options[index] || null)
		}

		_clearActiveOption() {
			this.listboxEl.removeAttribute('aria-activedescendant')
			this.optionEls.forEach((el) => el.removeAttribute('data-active'))
		}

		_setActiveOption(optionEl) {
			this.optionEls.forEach((el) => el.removeAttribute('data-active'))

			if (!optionEl) {
				this.listboxEl.removeAttribute('aria-activedescendant')
				return
			}

			optionEl.setAttribute('data-active', 'true')
			if (optionEl.id) this.listboxEl.setAttribute('aria-activedescendant', optionEl.id)
			optionEl.scrollIntoView({ block: 'nearest' })
		}

		_syncFromNative() {
			const selectedValue = this.nativeSelectEl.value

			this.optionEls.forEach((optionEl) => {
				const isSelected = optionEl.dataset.optionValue == selectedValue
				optionEl.classList.toggle('is-selected', isSelected)
				optionEl.setAttribute('aria-selected', isSelected ? 'true' : 'false')
				if (isSelected) this.triggerContentEl.innerHTML = optionEl.innerHTML
			})
		}
	}

	customElements.define('l-custom-select', LTACustomSelect)
}

/*****************************************
 * [COMPONENT]: MEDIA VIDEO
 ******************************************/

class LTAMediaVideo extends HTMLElement {
	constructor() {
		super()
		this._onClick = this._onClick.bind(this)
		this._onPosterClick = this._onPosterClick.bind(this)
		this._cleanups = []
	}

	connectedCallback() {
		if (this.dataset.videoPlayMode === 'trigger_by_button') {
			this.addEventListener('click', this._onClick)
			this._cleanups.push(() => this.removeEventListener('click', this._onClick))
		}

		const posterEl = this.querySelector('[data-poster]')
		if (!posterEl) return

		posterEl.addEventListener('click', this._onPosterClick)
		this._cleanups.push(() => posterEl.removeEventListener('click', this._onPosterClick))
	}

	disconnectedCallback() {
		this._cleanups.forEach((fn) => fn())
		this._cleanups = []
	}

	_onClick(event) {
		event.preventDefault()
		if (!this.hasAttribute('data-loaded')) {
			this.playVideo()
			return
		}

		this.hasAttribute('data-playing') ? this.pauseVideo() : this.playVideo()
	}

	_onPosterClick(event) {
		event.preventDefault()
		this.playVideo()
	}

	playVideo() {
		document.querySelectorAll('l-media-video').forEach((el) => {
			if (el !== this) el.pauseVideo()
		})

		if (!this.hasAttribute('data-loaded')) {
			const templateEl = this.querySelector('template')
			if (!templateEl) return
			;(this.querySelector('[data-video-container]') || this).append(templateEl.content.cloneNode(true))
			this.toggleAttribute('data-loaded', true)

			this.querySelector('iframe')?.addEventListener(
				'load',
				() => {
					if (this.hasAttribute('data-playing')) l_playMedia(this)
				},
				{ once: true }
			)
		}

		l_playMedia(this)
		this.toggleAttribute('data-playing', true)
	}

	pauseVideo() {
		l_pauseAllMedia(this)
		this.removeAttribute('data-playing')
	}
}

customElements.define('l-media-video', LTAMediaVideo)

/*****************************************
 * [COMPONENT]: SWIPER CAROUSEL
 ******************************************/

class LTASwiperCarousel extends HTMLElement {
	constructor() {
		super()
		this._onLayoutChange = l_debounce(this._onLayoutChange.bind(this), 50)
		this._swiperInitialized = false
	}

	connectedCallback() {
		if (window?.Swiper) {
			this.setupCarousel()
			return
		}

		document.addEventListener('l:vendor:loaded', () => {
			this.setupCarousel()
		})
	}

	disconnectedCallback() {
		this._layoutObserver?.disconnect()
	}

	setupCarousel() {
		if (this._swiperInitialized) return

		const configNode = this.querySelector('[data-carousel-config]')
		if (!configNode) return

		this.carouselConfig = JSON.parse(configNode.textContent)
		if (!this.carouselConfig) return

		// Custom elements default to inline; Swiper cannot measure slides until block-level.
		if (getComputedStyle(this).display === 'inline') {
			this.classList.add('l-block')
		}

		this.swiperSlideEls = [...this.querySelectorAll('.swiper-slide')]

		this.classList.remove('is-placeholder')
		this.swiperSlideEls.forEach((swiperSlide) => swiperSlide.classList.remove('l-hidden'))

		this.swiperCarousel = new window.Swiper(this, this.carouselConfig)
		this._swiperInitialized = true

		this._observeLayout()
		this._onLayoutChange()

		if (window.Shopify?.designMode) {
			this.designModeScroll()
		}

		if (this.dataset.dispatchEvent === 'true') {
			this.dispatchEvent(
				new CustomEvent('l:swiper:carousel:loaded', {
					bubbles: true,
					detail: {
						id: this.id || this.dataset.id || 'default',
					},
				})
			)
		}
	}

	_observeLayout() {
		this._layoutObserver?.disconnect()
		this._layoutObserver = new ResizeObserver(this._onLayoutChange)

		this._layoutObserver.observe(this)

		const wrapperEl = this.querySelector('.swiper-wrapper')
		if (wrapperEl) this._layoutObserver.observe(wrapperEl)

		this.swiperSlideEls.forEach((slide) => this._layoutObserver.observe(slide))
	}

	_syncHiddenSlides() {
		if (!this.swiperCarousel) return

		this.swiperSlideEls.forEach((slide) => {
			slide.classList.add('swiper-slide')
			slide.style.removeProperty('display')

			const hidden = getComputedStyle(slide).display === 'none'

			slide.classList.toggle('swiper-slide', !hidden)
			if (hidden) slide.style.display = 'none'
		})

		this.swiperCarousel.update()

		const activeEl = this.swiperCarousel.slides?.[this.swiperCarousel.activeIndex]
		if (!activeEl?.classList.contains('swiper-slide')) {
			this.swiperCarousel.slideTo(0, 0)
		}
	}

	_onLayoutChange() {
		if (!this.swiperCarousel) return

		this._syncHiddenSlides()

		if (this.carouselConfig?.navigation?.navigationHeightTarget) {
			this.setupNavigation()
		}
	}

	setupNavigation() {
		const navigation = this.carouselConfig?.navigation
		if (!navigation || !navigation.navigationHeightTarget) return

		const targetEl = this.querySelector(navigation.navigationHeightTarget)
		if (!targetEl) return

		const navTop = `${targetEl.offsetHeight / 2}px`

		const nextNavEls = document.querySelectorAll(navigation.nextEl)
		const prevNavEls = document.querySelectorAll(navigation.prevEl)

		nextNavEls.forEach((el) => el.style.setProperty('--l-swiper-top', navTop))
		prevNavEls.forEach((el) => el.style.setProperty('--l-swiper-top', navTop))
	}

	designModeScroll() {
		document.addEventListener('shopify:block:select', (event) => {
			const targetEl = event.target

			this.swiperSlideEls.forEach((swiperSlide, index0) => {
				if (targetEl === swiperSlide) this.slideTo(index0)
			})
		})
	}

	slideTo(index = 0) {
		if (this.swiperCarousel && typeof this.swiperCarousel.slideTo === 'function') {
			this.swiperCarousel.slideTo(index)
		}
	}
}

customElements.define('l-swiper-carousel', LTASwiperCarousel)

/*****************************************
 * [COMPONENT]:-DRAWER
 *****************************************/

class LTADrawer extends HTMLElement {
	static #pageInertStack = []

	static #isTopDrawer(drawerEl) {
		return LTADrawer.#pageInertStack.at(-1) === drawerEl
	}

	static #syncDrawerTopClass(removedEl) {
		if (removedEl) removedEl.classList.remove('is-drawer-top')

		const topEl = LTADrawer.#pageInertStack.at(-1) ?? null

		LTADrawer.#pageInertStack.forEach((drawerEl) => {
			drawerEl.classList.toggle('is-drawer-top', drawerEl === topEl)
		})
	}

	static #applyPageInert(activeDrawerEl) {
		const stack = LTADrawer.#pageInertStack

		Array.from(document.body.children).forEach((child) => {
			if (!activeDrawerEl) {
				child.inert = false
				return
			}

			// Keep every stacked drawer (and any body-level ancestor that contains one) interactive
			const isStackedDrawer = stack.includes(child)
			const containsStackedDrawer = stack.some((drawerEl) => child.contains(drawerEl))

			child.inert = !isStackedDrawer && !containsStackedDrawer
		})
	}

	static #pushPageInert(drawerEl) {
		const existingIndex = LTADrawer.#pageInertStack.indexOf(drawerEl)

		if (existingIndex !== -1) {
			LTADrawer.#pageInertStack.splice(existingIndex, 1)
		}

		LTADrawer.#pageInertStack.push(drawerEl)
		LTADrawer.#applyPageInert(drawerEl)
		LTADrawer.#syncDrawerTopClass()
	}

	static #popPageInert(drawerEl) {
		const index = LTADrawer.#pageInertStack.lastIndexOf(drawerEl)

		if (index === -1) return

		LTADrawer.#pageInertStack.splice(index, 1)
		LTADrawer.#applyPageInert(LTADrawer.#pageInertStack.at(-1) ?? null)
		LTADrawer.#syncDrawerTopClass(drawerEl)
	}

	constructor() {
		super()

		this.boundDrawerCloseOutsideOnClick = this.drawer_closeOutsideOnClick.bind(this)
		this.boundDrawerCloseOutsideOnEscape = this.drawer_closeOutsideOnEscape.bind(this)
		this.boundDrawerTriggerOnClick = this.drawer_triggerOnClick.bind(this)
		this.boundDrawerCloseOnClick = this.drawer_closeOnClick.bind(this)
		this.boundDrawerOpenHandler = this.drawer_onOtherDrawerOpen.bind(this)
	}

	connectedCallback() {
		this.setupDrawer()
	}

	disconnectedCallback() {
		this.drawer_destroy()
	}

	setupDrawer() {
		const showInBody = this.dataset.showInBody === 'true'

		// Move to body first; appendChild reconnects the element and runs setupDrawer again.
		// Must work for drawers outside #main-content too (e.g. global-group Age Gate).
		if (showInBody && this.parentElement !== document.body) {
			document.body.appendChild(this)
			return
		}

		if (this._drawerInitialized) return

		const templateEl = this.querySelector('template')
		if (templateEl) {
			const templateContentEl = templateEl.content.cloneNode(true)
			this.appendChild(templateContentEl)
		}

		this.drawer_init()
		this._drawerInitialized = true
	}

	drawer_destroy() {
		if (this.classList.contains('is-active')) {
			this.drawer_close()
		}

		if (this.triggerSelector) {
			document.removeEventListener('click', this.boundDrawerTriggerOnClick)
		}

		this.removeEventListener('click', this.boundDrawerCloseOnClick)
		document.removeEventListener('l:drawer:open', this.boundDrawerOpenHandler)
		window.removeEventListener('click', this.boundDrawerCloseOutsideOnClick)
		window.removeEventListener('keyup', this.boundDrawerCloseOutsideOnEscape)

		this._drawerInitialized = false
	}

	drawer_init() {
		this.triggerSelector = this.dataset.triggerSelector
		this.closeSelector = this.dataset.closeSelector || ''
		this.drawerInnerEl = this.querySelector('[data-drawer-inner]')
		this.triggerEl = null
		this.onlyOneDrawerOpen = this.dataset.onlyOneDrawerOpen === 'true'
		this.drawerName = this.dataset.drawerName || 'drawer'
		this.stackOver = (this.dataset.stackOver || '').trim().split(/\s+/).filter(Boolean)

		if (this.onlyOneDrawerOpen) {
			document.addEventListener('l:drawer:open', this.boundDrawerOpenHandler)
		}

		if (this.triggerSelector) {
			document.addEventListener('click', this.boundDrawerTriggerOnClick)
		}

		this.addEventListener('click', this.boundDrawerCloseOnClick)
		this.drawer_syncTriggerA11y(false)
	}

	drawer_getTriggerEls() {
		if (!this.triggerSelector) return []

		return Array.from(document.querySelectorAll(this.triggerSelector))
	}

	drawer_syncTriggerA11y(isExpanded) {
		this.drawer_getTriggerEls().forEach((triggerEl) => {
			if (this.id && !triggerEl.hasAttribute('aria-controls')) {
				triggerEl.setAttribute('aria-controls', this.id)
			}

			if (!triggerEl.hasAttribute('aria-haspopup')) {
				triggerEl.setAttribute('aria-haspopup', 'dialog')
			}

			triggerEl.setAttribute('aria-expanded', String(isExpanded))
		})
	}

	drawer_setDialogA11y(isOpen) {
		if (isOpen) {
			this.removeAttribute('aria-hidden')
			this.removeAttribute('tabindex')
		} else {
			this.setAttribute('aria-hidden', 'true')
			this.setAttribute('tabindex', '-1')
		}
	}

	drawer_lockPageInert() {
		LTADrawer.#pushPageInert(this)
	}

	drawer_unlockPageInert() {
		LTADrawer.#popPageInert(this)
	}

	drawer_triggerOnClick(event) {
		const triggerEl = event.target.closest(this.triggerSelector)
		if (!triggerEl) return

		event.preventDefault()
		this.drawer_open(triggerEl)
	}

	drawer_closeOnClick(event) {
		const internalCloseEl = event.target.closest('[data-close]')

		if (internalCloseEl && this.contains(internalCloseEl)) {
			this.drawer_close()
			return
		}

		if (this.closeSelector && event.target.closest(this.closeSelector)) {
			this.drawer_close()
		}
	}

	drawer_onOtherDrawerOpen(event) {
		const { drawerName, stackOver = [] } = event.detail || {}

		if (drawerName === this.drawerName) return

		// Incoming drawer stacks over this one — stay open underneath
		if (stackOver.includes(this.drawerName)) return

		this.drawer_close()
	}

	drawer_open(triggerEl) {
		l_setupVariablesBeforeOpenModal()
		l_lockBodyScroll(this.drawerName)

		// Open drawer
		this.classList.remove('l-hidden')

		requestAnimationFrame(() => {
			this.classList.add('is-active')
		})

		// Setup focus trap on main content
		if (triggerEl) {
			this.triggerEl = triggerEl
			l_trapFocus(this.drawerInnerEl, this.defaultElementToFocus, this.enableFocusRange !== false)
		}

		// Set up accessibility
		this.drawer_setDialogA11y(true)
		this.drawer_syncTriggerA11y(true)
		this.drawer_lockPageInert()

		// Set global events using bound handlers
		window.addEventListener('click', this.boundDrawerCloseOutsideOnClick)
		window.addEventListener('keyup', this.boundDrawerCloseOutsideOnEscape)

		// Dispatch event to notify that the drawer is open
		document.dispatchEvent(
			new CustomEvent('l:drawer:open', {
				detail: {
					drawerName: this.drawerName,
					stackOver: this.stackOver,
				},
			})
		)
	}

	drawer_close() {
		l_unLockBodyScroll(this.drawerName)

		// Close drawer
		this.classList.remove('is-active')
		this.classList.remove('is-drawer-top')

		window.l_debounce(() => {
			this.classList.add('l-hidden')
		}, 400)()

		// Remove focus trap
		if (this.triggerEl) {
			l_removeTrapFocus(this.triggerEl)
			this.triggerEl = null
		}

		// Remove accessibility
		this.drawer_setDialogA11y(false)
		this.drawer_syncTriggerA11y(false)
		this.drawer_unlockPageInert()

		// Remove global events using the same bound handlers
		window.removeEventListener('click', this.boundDrawerCloseOutsideOnClick)
		window.removeEventListener('keyup', this.boundDrawerCloseOutsideOnEscape)
	}

	drawer_closeOutsideOnClick(event) {
		if (event._lDrawerHandled) return
		if (!this.classList.contains('is-active')) return
		if (!LTADrawer.#isTopDrawer(this)) return

		const target = event.target
		// Same click closed/interacted with another drawer (e.g. its [data-close]) — ignore
		const sourceDrawer = typeof target.closest === 'function' ? target.closest('.l-drawer') : null
		if (sourceDrawer && sourceDrawer !== this) return

		const triggerSelector = this.dataset.drawerTriggerSelector || 'l-drawer-trigger'
		const isDrawerTrigger = target.closest(triggerSelector)

		const isTriggerClick = this.triggerSelector && target.closest(this.triggerSelector)
		const isOutsideClick = !this.drawerInnerEl.contains(target) && !isTriggerClick && !isDrawerTrigger

		if (!isOutsideClick) return

		event._lDrawerHandled = true
		this.drawer_close()
	}

	drawer_closeOutsideOnEscape(event) {
		if (event._lDrawerHandled || event.defaultPrevented) return
		if (!this.classList.contains('is-active')) return
		if (!LTADrawer.#isTopDrawer(this)) return

		if (event.code.toUpperCase() !== 'ESCAPE') return

		event.preventDefault()
		event._lDrawerHandled = true
		this.drawer_close()
	}
}

class LTADrawerVideo extends LTADrawer {
	setupDrawer() {
		const showInBody = this.dataset.showInBody === 'true'

		if (showInBody && this.parentElement !== document.body) {
			document.body.appendChild(this)
			return
		}

		if (this._drawerInitialized) return

		this.drawer_init()
		this._drawerInitialized = true
	}

	drawer_open(triggerEl) {
		if (typeof l_pauseAllMedia === 'function') l_pauseAllMedia(document)

		super.drawer_open(triggerEl)

		this._mountVideo()

		requestAnimationFrame(() => {
			this._playVideo()
		})
	}

	drawer_close() {
		this._pauseVideo()
		super.drawer_close()
	}

	_mountVideo() {
		if (this.hasAttribute('data-video-loaded')) return

		const templateEl = this.querySelector('[data-video-template]')
		const containerEl = this.querySelector('[data-video-container]')
		if (!templateEl || !containerEl) return

		containerEl.append(templateEl.content.cloneNode(true))
		this.toggleAttribute('data-video-loaded', true)
	}

	_playVideo() {
		const mediaVideoEl = this.querySelector('l-media-video')

		if (mediaVideoEl?.playVideo) {
			mediaVideoEl.playVideo()
			return
		}

		if (typeof l_playMedia === 'function') l_playMedia(this)
	}

	_pauseVideo() {
		this.querySelector('l-media-video')?.pauseVideo?.()

		if (typeof l_pauseAllMedia === 'function') l_pauseAllMedia(this)
	}
}

customElements.define('l-drawer', LTADrawer)
customElements.define('l-drawer-video', LTADrawerVideo)

class LTACollapsibleTab extends HTMLElement {
	constructor() {
		super()

		this._onTriggerClick = (e) => this.toggle(e)
		this._onTriggerKeydown = (e) => this._handleTriggerKeydown(e)
	}

	connectedCallback() {
		this.triggerEl = this.querySelector('[data-trigger]')
		this.contentEl = this.querySelector('[data-content]')

		if (!this.triggerEl || !this.contentEl) return

		this.expandedClass = 'is-expanded'
		this.collapsedClass = 'is-collapsed'
		this.collapsedHeight = '0px'
		this.oneAtATime = true
		this.isScrollIntoView = this.dataset.scrollIntoView === 'true'
		this.trapFocus = this.dataset.trapFocus !== 'false'
		this.keyboardNav = this.dataset.keyboardNav === 'true'

		this.transitionendEvent = this.transitionendEventName()

		this.dataset.oneOpen === 'false' && (this.oneAtATime = false)

		if (this.getAttribute('open') === 'true') {
			this.selected = true
			this.contentEl.removeAttribute('hidden')
			this.contentEl.classList.remove('l-hidden')
			this.classList.add(this.expandedClass)
			this.setExpandedAria(false)
		} else {
			this.contentEl.style.height = this.collapsedHeight
			this.classList.add(this.collapsedClass)
			this.setCollapsedAria(null, false)
		}

		this.triggerEl.addEventListener('click', this._onTriggerClick)

		if (this.keyboardNav) {
			this.triggerEl.addEventListener('keydown', this._onTriggerKeydown)
		}
	}

	disconnectedCallback() {
		this.triggerEl?.removeEventListener('click', this._onTriggerClick)
		this.triggerEl?.removeEventListener('keydown', this._onTriggerKeydown)
	}

	_getAccordionTriggers(container) {
		return Array.from(container.querySelectorAll('l-collapsible-tab[data-keyboard-nav="true"]'))
			.filter((tab) => {
				if (tab.hidden || tab.classList.contains('l-hidden')) return false

				const item = tab.hasAttribute('data-faq-item') ? tab : tab.closest('[data-faq-item]')

				return item && !item.hidden && !item.classList.contains('l-hidden')
			})
			.map((tab) => tab.querySelector('[data-trigger]'))
			.filter((triggerEl) => triggerEl && isVisible(triggerEl))
	}

	_handleTriggerKeydown(event) {
		if (!this.keyboardNav) return

		const key = event.code?.toUpperCase()
		const navigationKeys = ['ARROWDOWN', 'ARROWUP', 'HOME', 'END']

		if (!navigationKeys.includes(key)) return

		const container =
			this.closest('[data-faq-category]') ||
			this.closest('[data-faq-list]') ||
			this.closest('[data-collapsible-wrapper]') ||
			this.parentElement

		if (!container) return

		const triggers = this._getAccordionTriggers(container)
		const currentIndex = triggers.indexOf(this.triggerEl)

		if (currentIndex === -1 || triggers.length < 2) return

		event.preventDefault()

		let nextIndex = currentIndex

		if (key === 'ARROWDOWN') {
			nextIndex = (currentIndex + 1) % triggers.length
		} else if (key === 'ARROWUP') {
			nextIndex = (currentIndex - 1 + triggers.length) % triggers.length
		} else if (key === 'HOME') {
			nextIndex = 0
		} else if (key === 'END') {
			nextIndex = triggers.length - 1
		}

		triggers[nextIndex]?.focus()
	}

	toggle(e) {
		e.preventDefault()

		this.selected ? this.close() : this.open()

		/* Close another tab and open only the current tab. */
		if (this.selected && this.oneAtATime) {
			const tabsContainer = this.closest('[data-collapsible-wrapper]')
			const collapsibleTabs = tabsContainer?.querySelectorAll('l-collapsible-tab')

			collapsibleTabs?.length &&
				collapsibleTabs.forEach((tab) => {
					tab !== this && tab.selected && tabsContainer !== tab && tab.close()
				})
		}
	}

	open() {
		this.selected = true
		this.expand()

		this.setExpandedAria(this.trapFocus)
	}

	close() {
		this.selected = false
		this.collapse()

		this.setCollapsedAria(this.triggerEl, this.trapFocus)
	}

	expand() {
		const onTransitionEnd = ((event) => {
			if (event.target === this.contentEl) {
				this.contentEl.removeEventListener(this.transitionendEvent, onTransitionEnd)

				this.isOpen &&
					requestAnimationFrame(() => {
						this.contentEl.style.transition = '0'
						this.contentEl.style.height = 'auto'

						requestAnimationFrame(() => {
							this.contentEl.style.height = null
							this.contentEl.style.transition = null
						})
					})
			}
		}).bind(this)

		this.contentEl.addEventListener(this.transitionendEvent, onTransitionEnd)
		this.isOpen = true

		this.contentEl.removeAttribute('hidden')
		this.contentEl.classList.remove('l-hidden')

		this.classList.add(this.expandedClass)
		this.classList.remove(this.collapsedClass)

		this.contentEl.style.height = this.contentEl.scrollHeight + 'px'
	}

	collapse() {
		const onTransitionEnd = ((event) => {
			if (event.target === this.contentEl) {
				this.contentEl.removeEventListener(this.transitionendEvent, onTransitionEnd)

				if (!this.isOpen) {
					this.classList.add(this.collapsedClass)
				}

				this.contentEl.setAttribute('hidden', 'hidden')
				this.contentEl.classList.add('l-hidden')
			}
		}).bind(this)

		this.contentEl.addEventListener(this.transitionendEvent, onTransitionEnd)
		this.isOpen = false
		this.classList.remove(this.expandedClass)

		requestAnimationFrame(() => {
			this.contentEl.style.transition = '0'
			this.contentEl.style.height = this.contentEl.scrollHeight + 'px'

			requestAnimationFrame(() => {
				this.contentEl.style.transition = null
				this.contentEl.style.height = this.collapsedHeight
			})
		})

		if (this.isScrollIntoView) {
			l_debounce(() => {
				this.scrollIntoView({ behavior: 'smooth', block: 'center' })
			}, 400)()
		}
	}

	destroy() {
		// Remove event listener using the same stored reference
		this.triggerEl && this.triggerEl.removeEventListener('click', this._onTriggerClick)
		this.contentEl && this.contentEl.removeAttribute('aria-hidden')
		this.contentEl && (this.contentEl.style.height = 'auto')

		this.classList.remove(this.expandedClass, this.collapsedClass)
		this.removeAttribute('open')
	}

	transitionendEventName() {
		let eventName,
			testElement = document.createElement('div'),
			eventNames = {
				transition: 'transitionend',
				OTransition: 'otransitionend',
				MozTransition: 'transitionend',
				WebkitTransition: 'webkitTransitionEnd',
			}

		for (eventName in eventNames) {
			if (eventNames.hasOwnProperty(eventName) && testElement.style[eventName] !== false) {
				return eventNames[eventName]
			}
		}
	}

	setExpandedAria(autoFocus = true) {
		this.setAttribute('open', true)

		this.triggerEl.setAttribute('aria-expanded', 'true')
		this.contentEl.removeAttribute('aria-hidden')
		this.contentEl.removeAttribute('tabindex')
		l_enableFocusableElements(this.contentEl)

		if (autoFocus && this.trapFocus) {
			l_trapFocus(this)
		}
	}

	setCollapsedAria(elementToFocus = this.triggerEl, enableTrapFocus = true) {
		this.removeAttribute('open')

		this.triggerEl.setAttribute('aria-expanded', 'false')
		this.contentEl.setAttribute('aria-hidden', 'true')
		this.contentEl.setAttribute('tabindex', '-1')

		l_disableFocusableElements(this.contentEl)
		enableTrapFocus && this.trapFocus && l_removeTrapFocus(elementToFocus)
	}
}

customElements.define('l-collapsible-tab', LTACollapsibleTab)

/*****************************************
 * [COMPONENT]: RICHTEXT MORE LESS
 ******************************************/

class LTARichtextMoreLess extends LTACollapsibleTab {
	connectedCallback() {
		this.triggerEl = this.querySelector('[data-trigger]')
		this.contentEl = this.querySelector('[data-content]')
		this.bodyEl = this.querySelector('[data-rte-body]') || this.contentEl

		if (!this.triggerEl || !this.contentEl) return

		this.expandedClass = 'is-expanded'
		this.collapsedClass = 'is-collapsed'
		this.collapsedHeight = 'auto'
		this.oneAtATime = false
		this.isScrollIntoView = false
		this._contentFits = false

		this.transitionendEvent = this.transitionendEventName()
		this.moreLabel = this.triggerEl.dataset.labelMore
		this.lessLabel = this.triggerEl.dataset.labelLess

		this._onResize = l_debounce(() => this.measure(), 150)
		this._cleanups = []

		this.triggerEl.addEventListener('click', this._onTriggerClick)
		window.addEventListener('resize', this._onResize)

		this._resizeObserver = new ResizeObserver(this._onResize)
		this._resizeObserver.observe(this.contentEl)

		this._cleanups.push(
			() => this.triggerEl.removeEventListener('click', this._onTriggerClick),
			() => window.removeEventListener('resize', this._onResize),
			() => this._resizeObserver.disconnect()
		)

		if (document.fonts?.ready) {
			document.fonts.ready.then(() => this.measure())
		} else {
			requestAnimationFrame(() => this.measure())
		}
	}

	disconnectedCallback() {
		this._cleanups?.forEach((fn) => fn())
		this._cleanups = []
	}

	_getClampLines() {
		const raw = getComputedStyle(this).getPropertyValue('--l-rte-clamp-lines').trim()
		const lines = parseInt(raw, 10)
		return Number.isFinite(lines) && lines > 0 ? lines : 4
	}

	_styleMeasureClone(clone, width, { clamp = false, lines = 4 } = {}) {
		clone.removeAttribute('data-rte-body')
		clone.style.cssText = [
			'position:absolute',
			'visibility:hidden',
			'pointer-events:none',
			'inset-inline-start:-99999px',
			'top:0',
			`width:${width}px`,
			'height:auto',
			'max-height:none',
			'margin:0',
		].join(';')

		if (clamp) {
			clone.style.setProperty('display', '-webkit-box', 'important')
			clone.style.setProperty('-webkit-box-orient', 'vertical', 'important')
			clone.style.setProperty('overflow', 'hidden', 'important')
			clone.style.setProperty('-webkit-line-clamp', String(lines), 'important')
			clone.style.setProperty('line-clamp', String(lines), 'important')
			return
		}

		clone.style.setProperty('display', 'block', 'important')
		clone.style.setProperty('overflow', 'visible', 'important')
		clone.style.setProperty('-webkit-line-clamp', 'unset', 'important')
		clone.style.setProperty('line-clamp', 'unset', 'important')
	}

	_measureHeights() {
		const width = this.bodyEl.getBoundingClientRect().width
		if (width <= 0) return { fullHeight: 0, collapsedHeight: 0 }

		const lines = this._getClampLines()

		// Full height without clamp (mixed headings/paragraphs keep real metrics).
		const fullClone = this.bodyEl.cloneNode(true)
		this._styleMeasureClone(fullClone, width, { clamp: false })
		this.appendChild(fullClone)
		const fullHeight = fullClone.getBoundingClientRect().height
		fullClone.remove()

		// Collapsed height from real line-clamp — not body-line-height × N
		// (headings are taller, so N × <p> lh was clipping too early).
		const clampClone = this.bodyEl.cloneNode(true)
		this._styleMeasureClone(clampClone, width, { clamp: true, lines })
		this.appendChild(clampClone)
		const collapsedHeight = clampClone.getBoundingClientRect().height
		clampClone.remove()

		return { fullHeight, collapsedHeight }
	}

	measure() {
		if (!this.contentEl || !this.triggerEl || this._isAnimating || this._isMeasuring) return

		this._isMeasuring = true

		try {
			const { fullHeight, collapsedHeight } = this._measureHeights()
			const truncateNeeded = fullHeight > collapsedHeight + 1

			this._collapsedHeight = collapsedHeight
			this.collapsedHeight = `${collapsedHeight}px`

			if (!truncateNeeded) {
				this._contentFits = true
				this.selected = false
				this.isOpen = false
				this.triggerEl.hidden = true
				this.contentEl.style.height = 'auto'
				this.classList.add(this.expandedClass)
				this.classList.remove(this.collapsedClass)
				this.removeAttribute('open')
				this.triggerEl.setAttribute('aria-expanded', 'false')
				this.triggerEl.textContent = this.moreLabel
				return
			}

			this._contentFits = false
			this.triggerEl.hidden = false

			if (this.selected) {
				this.contentEl.style.height = 'auto'
				this.classList.add(this.expandedClass)
				this.classList.remove(this.collapsedClass)
				this.triggerEl.textContent = this.lessLabel
				return
			}

			this.selected = false
			this.isOpen = false
			this.contentEl.style.height = this.collapsedHeight
			this.classList.remove(this.expandedClass)
			this.classList.add(this.collapsedClass)
			this.setCollapsedAria(null, false)
			this.triggerEl.textContent = this.moreLabel
		} finally {
			this._isMeasuring = false
		}
	}

	toggle(e) {
		e.preventDefault()
		if (this._contentFits) return

		if (this.selected) {
			this.close()
			this.triggerEl.textContent = this.moreLabel
			return
		}

		this.open()
		this.triggerEl.textContent = this.lessLabel
		this.triggerEl.hidden = false
	}

	open() {
		this._isAnimating = true
		this.selected = true
		this._contentFits = false
		this.expand()
		this.setExpandedAria(false)
	}

	close() {
		this.selected = false
		this.collapsedHeight = `${this._collapsedHeight}px`
		this._isAnimating = true
		this.collapse()
		this.setCollapsedAria(null, false)
	}

	expand() {
		const onTransitionEnd = ((event) => {
			if (event.target !== this.contentEl) return

			this.contentEl.removeEventListener(this.transitionendEvent, onTransitionEnd)
			this._isAnimating = false

			if (!this.isOpen) return

			requestAnimationFrame(() => {
				this.contentEl.style.transition = '0'
				this.contentEl.style.height = 'auto'

				requestAnimationFrame(() => {
					this.contentEl.style.height = null
					this.contentEl.style.transition = null
				})
			})
		}).bind(this)

		this.contentEl.addEventListener(this.transitionendEvent, onTransitionEnd)
		this.isOpen = true
		this.classList.add(this.expandedClass)
		this.classList.remove(this.collapsedClass)
		this.contentEl.style.height = this.contentEl.scrollHeight + 'px'
	}

	collapse() {
		const onTransitionEnd = ((event) => {
			if (event.target !== this.contentEl) return

			this.contentEl.removeEventListener(this.transitionendEvent, onTransitionEnd)

			if (!this.isOpen) {
				this.classList.add(this.collapsedClass)
				this.classList.remove(this.expandedClass)
				this.contentEl.style.height = this.collapsedHeight
			}

			this._isAnimating = false
			this.measure()
		}).bind(this)

		this.contentEl.addEventListener(this.transitionendEvent, onTransitionEnd)
		this.isOpen = false

		requestAnimationFrame(() => {
			this.contentEl.style.transition = '0'
			this.contentEl.style.height = this.contentEl.scrollHeight + 'px'

			requestAnimationFrame(() => {
				this.contentEl.style.transition = null
				this.contentEl.style.height = this.collapsedHeight
			})
		})
	}

	setExpandedAria() {
		this.setAttribute('open', true)
		this.triggerEl.setAttribute('aria-expanded', 'true')
	}

	setCollapsedAria() {
		this.removeAttribute('open')
		this.triggerEl.setAttribute('aria-expanded', 'false')
	}
}

if (!customElements.get('l-richtext-more-less')) {
	customElements.define('l-richtext-more-less', LTARichtextMoreLess)
}

/*****************************************
 * [GLOBAL-E]: theme hide CSS (same gates as addStyles)
 ******************************************/
;(function () {
	function isGeCssLinkAlreadyOnPage(params) {
		const href = `${params.appUrl}resources/css/${params.mid}/${params.countryCode}`
		return [...document.querySelectorAll('link[href]')].some((link) => link.href.indexOf(href) > -1)
	}

	// Same as GlobaleApp constructor skip + addStyles() in the app script.
	function shouldAddGeHideStyles(params) {
		if (!params || params.checkoutId) return false
		if (!params.masSkipCssFile && isGeCssLinkAlreadyOnPage(params)) return false
		return Array.isArray(params.operatedCountries) && params.operatedCountries.indexOf(params.countryCode) > -1
	}

	function addCustomGeHideStyles() {
		if (document.getElementById('custom-ge-hide-styles')) return
		if (!shouldAddGeHideStyles(window.GLBE_PARAMS)) return

		const style = document.createElement('style')
		style.id = 'custom-ge-hide-styles'
		style.textContent = `
    .custom-ge-hidden,

    .sealsubs-target-element,
    .rebuy-cart__flyout-item-subscription,


    #hp-features-bar .swiper-slide:first-of-type,
    #footer-features .swiper-slide:first-of-type,
    #hp-bestselling-products .subheading {
      display: none !important;
    }

    #hp-bestselling-products .heading__section h2 {
      margin-block-end: 0;
    }`

		document.head.appendChild(style)
	}

	document.addEventListener('glbeParamsSet', addCustomGeHideStyles)

	if (window.GLBE_PARAMS) {
		addCustomGeHideStyles()
		return
	}

	const startedAt = Date.now()
	const pollId = setInterval(() => {
		if (window.GLBE_PARAMS || Date.now() - startedAt >= 2000) {
			clearInterval(pollId)
			addCustomGeHideStyles()
		}
	}, 50)
})()

